import { Component, OnInit, Input } from '@angular/core';

import { UntypedFormGroup } from '@angular/forms';
import { FormService } from '@bayclubs/utils';
import { DropdownMultiselectItem } from '@bayclubs/drop-down';

import { FilterApiService } from '../../../../services/api/filter-api.service';
import { ReportsEventService, ReportType } from '../../reports-event.service';
import { EnrollmentReportFilter } from '../../../../models/filters/reports-filters.model';
import { FilterDropDownsService } from '../../../../services/filter-dropdowns.service';

@Component({
    selector: 'app-enrollment-report-search-criteria',
    templateUrl: './enrollment-report-search-criteria.component.html',
    styleUrls: ['./enrollment-report-search-criteria.component.scss'],
    standalone: false
})
export class EnrollmentReportSearchCriteriaComponent implements OnInit {
    @Input()
    public searchForm: UntypedFormGroup;

    public clubDropdownItems: DropdownMultiselectItem[] = [];
    public categorieDropdownItems: DropdownMultiselectItem[] = [];
    public campTypeDropdownItems: DropdownMultiselectItem[] = [];

    public isBusy: boolean = true;

    @Input() public filters: EnrollmentReportFilter;

    constructor(
        private reportsEvent: ReportsEventService,
        private filtersApi: FilterApiService,
        private filterDropDownsService: FilterDropDownsService
    ) {}

    ngOnInit() {
        this.isBusy = true;
        this.loadFilters();
    }

    public onSubmit() {
        this.reportsEvent.onSearch(true);
    }

    public onSubmitV2() {
        this.reportsEvent.onSearch(true);
    }

    public isFormValid() {
        return FormService.isFormValid(this.searchForm);
    }

    private loadFilters() {
        this.filtersApi.get(false).subscribe(data => {
            if (data.isSuccess) {
                this.clubDropdownItems = this.filterDropDownsService.createClubDropDownItemsWitId(
                    data.value,
                    this.filters.clubIds
                );
                this.categorieDropdownItems = this.filterDropDownsService.createCategoriesDropDownItems(
                    data.value,
                    this.filters.categories
                );
                this.campTypeDropdownItems = this.filterDropDownsService.createCampTypeDropDownItems(this.filters.campTypes);

                this.isBusy = false;
            }
        });
    }

    public onClubsChanged(data: Array<DropdownMultiselectItem>) {
        let clubCodes = data.map(x => x.id);
        this.searchForm.controls['clubIds'].setValue(clubCodes);
    }

    public onCategoryChanged(data: Array<DropdownMultiselectItem>) {
        let categories = data.map(x => x.id);
        this.searchForm.controls['categories'].setValue(categories);
    }

    public onCampTypeChanged(data: Array<DropdownMultiselectItem>) {
        const campTypes = data.map(x => x.id);
        this.searchForm.controls['campTypes'].setValue(campTypes);
    }

    public get isTimeFromDisabled() {
        return !this.searchForm.controls['dateFrom'].value;
    }

    public get isTimeToDisabled() {
        return !this.searchForm.controls['dateTo'].value;
    }
}
